<template>
  <div v-if="label" class="bingo-label">
    <span
      v-for="(letter, i) in labelLetters"
      :key="i"
      class="bingo-label__letter"
    >
      {{ letter }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'BingoLabel',
  props: {
    label: {
      type: String,
      default: 'BINGO'
    }
  },
  computed: {
    labelLetters() {
      const chars = (this.label || '').replace(/\s/g, '').toUpperCase().split('');
      return chars.slice(0, 20);
    }
  }
};
</script>

<style lang="scss" scoped>
.bingo-label {
  display: flex;
  gap: 6px;
  margin-bottom: .25rem !important;
  background: linear-gradient(
    135deg,
    rgb(var(--v-theme-primary)),
    rgba(var(--v-theme-primary), 0.8)
  );
  color: rgb(var(--v-theme-on-primary));
  font-weight: 700;
  padding: 4px 0;
  border-radius: 12px;
}

.bingo-label__letter {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
